<template>
  <div>
    <div class="date-btn">
      <van-icon name="calender-o" />
      <span @click="showStart = true">
        {{ getStartDate }}
      </span>
      至
      <span @click="showEnd = true">
        {{ getEndDate }}
      </span>
      <van-icon name="arrow-down" />
    </div>
    <van-popup v-model="showStart" position="bottom">
      <van-datetime-picker
        v-model="startDate"
        @cancel="showStart = false"
        @confirm="confirmPicker"
        type="date"
        title="选择开始时间"
      />
    </van-popup>
    <van-popup v-model="showEnd" position="bottom">
      <van-datetime-picker
        v-model="endDate"
        @cancel="showEnd = false"
        @confirm="confirmPicker"
        type="date"
        title="选择结束时间"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      showStart: false,
      showEnd: false,
      startDate: new Date(),
      endDate: new Date()
    };
  },
  computed: {
    getStartDate() {
      return this.startDate
        ? this.$moment(this.startDate).format("YYYY-MM-DD")
        : "";
    },
    getEndDate() {
      return this.endDate
        ? this.$moment(this.endDate).format("YYYY-MM-DD")
        : "";
    }
  },
  created() {
    this.startDate = this.$moment()
      .add(0, "day")
      .toDate();
    this.endDate = this.$moment()
      .add(7, "day")
      .toDate();
  },
  methods: {
    confirmPicker() {
      this.showStart = false;
      this.showEnd = false;
      this.$emit("dateSelected", this.startDate, this.endDate);
    }
  }
};
</script>

<style lang="less" scoped>
.date-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 2.38rem;
  margin: 12px 15px 0 15px;
  padding: 0 0.88rem;
  line-height: 2.38rem;
  border: solid 1px #fff;
  border-radius: 4px;
}
</style>
